import { isClinicalAdmin } from "@/routers/router-guardians"

const routes = [
  {
    path: "/dashboard/occupational-health/order-requests",
    name: "order-requests",
    component: () => import("@/modules/occupational-health/pages/order-requests/OrderRequestsPage.vue")
  },
  {
    path: "/dashboard/occupational-health-records",
    name: "occupational-health-records",
    component: () =>
      import("@/modules/occupational-health/pages/occupational-health-records/OccupationalHealthRecords.vue"),
    beforeEnter(to, from, next) {
      isClinicalAdmin(to, from, next)
    }
  },
  {
    path: "/dashboard/clinic-requests",
    name: "clinic-requests",
    component: () => import("@/modules/occupational-health/pages/clinic-requests/ClinicRequests.vue"),
    beforeEnter(to, from, next) {
      isClinicalAdmin(to, from, next)
    }
  }
]

export default routes
